import { FormSubmitOptions } from "@mongez/react-form";
import { useNavigate } from "@remix-run/react";
import { URLS } from "@core/shared/utils";
import { unlockCodePortal } from "../atoms/unlock-code.atom";

export const useUnlockCode = () => {
  const navigate = useNavigate();

  const handleSubmit = ({ values, form }: FormSubmitOptions) => {
    navigate(URLS.unlockCode.redeem(values.code));
    form.reset();
    unlockCodePortal.close();
  };

  return {
    handleSubmit,
  };
};
